import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSignUpStyle0 = cosmosIconCss;

const CosmosIconSignUp$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSignUp extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '60e71841cebe24c384ec532bc22bdf6bdb8585ed', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ff6c2f45a1498147deee06f08da743a0c6111b28', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '343c93295f0f9487c2a9c4c984b87e9b606da685', d: "M18.486 10.536a.52.52 0 0 1 .143-.395l.502-.515c.276-.283.75-.147.799.246a9 9 0 1 1-7.317-7.728c.374.068.498.52.233.792l-.462.474a.52.52 0 0 1-.438.149 7.5 7.5 0 1 0 6.54 6.977Zm1.425-6.081c.136-.136.114-.379-.049-.542l-1.768-1.774c-.163-.164-.405-.186-.54-.05l-1.228 1.232 2.357 2.366 1.228-1.232Z", fill: "currentColor" }), h("path", { key: '8199754c6145e35e8d4acdf9b1582b6fe0d344b3', d: "m15.441 4.209-6.483 6.505-.935 2.731a.418.418 0 0 0 .523.534l2.77-.899 6.483-6.506-2.358-2.365Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSignUpStyle0; }
}, [1, "cosmos-icon-sign-up", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-sign-up"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-sign-up":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSignUp$1);
            }
            break;
    } });
}

const CosmosIconSignUp = CosmosIconSignUp$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSignUp, defineCustomElement };
